import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTopDeudores } from '@/hooks/useReportes'
import { cn } from '@/lib/utils'
import { TablaDeudores } from '../TablaDeudores'
import { LIMITE_TOP_DEUDORES } from './TopDeudores'

/**
 * Sección plegable con la tabla completa de deudores. Arranca cerrada.
 * La tabla se monta recién al abrirla, así sus consultas no corren antes.
 * La cantidad del rótulo sale de la misma consulta del top de deudores.
 */
export function ListaDeudores() {
  const [abierta, setAbierta] = useState(false)
  const { data } = useTopDeudores(LIMITE_TOP_DEUDORES)
  const rotulo = !data ? 'Ver los deudores' : data.total === 1 ? 'Ver el deudor' : `Ver los ${data.total} deudores`

  return (
    <section className="space-y-4">
      <Button
        variant="outline"
        className="w-full justify-between"
        aria-expanded={abierta}
        aria-controls="lista-deudores"
        onClick={() => setAbierta((v) => !v)}
      >
        {abierta ? 'Ocultar deudores' : rotulo}
        <ChevronDown className={cn('h-4 w-4 transition-transform', abierta && 'rotate-180')} />
      </Button>
      {abierta && (
        <div id="lista-deudores">
          <TablaDeudores />
        </div>
      )}
    </section>
  )
}
